import styles from "../styles/_layouts/header.module.scss";

const Header = () => {
  return (
    <header className={styles.header}>
      <p className={styles.date}>
        Today's Date: <span>21.12.2022</span>
      </p>
      <p className={styles.weather}>
        The weather in the hut: <span>13°C</span>
      </p>
      <img src="/assets/sun.png" alt="sun" />
    </header>
  );
};

export default Header;
